<template>
  <div>
    <router-view v-if="!isLoading" ref="child" @sendImage="handleImg" />
    <LandscapeCard v-show="showLandscapeWarning" :active="showLandscapeWarning" />
    <OnboardingLoading v-if="isLoading" loadingText="Verificando compra..."
    successText="Compra encontrada"
    onSucessGoTo="onboarding-next-steps" :hideErrorLoading="true" onErrorGoTo="onboarding-error" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import debug from 'debug';
import UtilMixin from '@/mixins/util';
import Logger from '../../../lib/logger';
import LandscapeCard from '../components/LandscapeCard.vue';
import OnboardingLoading from './OnboardingLoading.vue';
import onboardingService from '../onboarding.service';

const log = debug('vue:onboarding-template');

export default {
  name: 'onboarding-template',
  data: () => ({
    landscape: false,
    isLoading: true,
  }),
  mixins: [UtilMixin],
  components: { LandscapeCard, OnboardingLoading },
  computed: {
    ...mapState('onboarding', [
      'downPayment',
      'downPaymentPaid',
      'documentSended',
      'onboardingId',
      'step',
      'nextRoute',
      'afterLoadingRoute',
      'isOnboardingTokenValid',
    ]),
    ...mapState('auth', [
      'token',
    ]),
    showLandscapeWarning() {
      return this.isMobile() && this.landscape;
    },
  },
  methods: {
    ...mapActions('onboarding', ['getOnboarding', 'updateStep']),
    ...mapActions('auth', ['setToken']),
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    watchLandscape() {
      if (window.orientation !== 0) this.landscape = true;
      window.addEventListener('orientationchange', () => {
        if (window.orientation === 0) this.landscape = false;
        else this.landscape = true;
      }, false);
    },
    async handleImg({ img, step, loadingPath, extraData }) {
      await this.$router.replace({
        name: loadingPath || `onboarding-${step}-loading`,
        query: this.$route.query,
      });
      try {
        const { data } = await onboardingService.sendImage({
          onboardingId: this.onboardingId,
          step,
          imageB64: img,
          extraData,
        });
        const { photoOk } = data;
        if (photoOk) {
          this.updateStep({ step: data.onboarding.step });
          return this.$refs.child.handleResponse({ nextRoute: this.nextRoute });
        }

        return this.$refs.child.handleResponse({ retry: true });
      } catch (error) {
        if (error && error.response) {
          if (error.response.status === 413) {
            this.$refs.child.$data.errorMsg = 'Imagem muito pesada';
            return this.$refs.child.handleResponse({ retry: true });
          }

          if (
            error.response.status === 500
            && error.response.data
            && error.response.data.startsWith('child "base64Img" fails')
          ) {
            this.$refs.child.$data.errorMsg = 'Arquivo inválido! Escolha uma imagem';
            return this.$refs.child.handleResponse({ retry: true });
          }

          return this.$refs.child.handleResponse({ error });
        }

        return this.$refs.child.handleResponse({ error: new Error('Unhandled Error') });
      }
    },
  },
  async mounted() {
    if (!this.inIframe()) {
      this.watchLandscape();
    }
    const {
      transactionId,
      onboardingToken,
      proposalId,
      f,
      errorTag,
      facetecErrorCount,
      forceResendToken,
      payWithCredit,
      payWithCreditPaid,
    } = this.$route.query;

    log('query', transactionId, onboardingToken);
    await this.setToken({ token: onboardingToken });
    this.getOnboarding({ transactionId, onboardingToken, facetecErrorCount })
      .catch((error) => {
        Logger.error(error);
        this.setToken({ token: null });
      })
      .finally(async () => {
        if (this.isOnboardingTokenValid && errorTag !== 'facetec-error') {
          const queryObject = {
            onboardingToken,
            transactionId,
            proposalId,
            downPayment: this.downPayment,
            downPaymentPaid: this.downPaymentPaid,
            documentSended: this.documentSended,
            payWithCredit,
            payWithCreditPaid,
            errorTag,
          };

          if (forceResendToken) queryObject.forceResendToken = true;

          await this.$router.replace({
            name: f ? this.nextRoute : this.afterLoadingRoute,
            query: queryObject,
          });
        }
        this.isLoading = false;
      });
  },
};
</script>
